import React from 'react';
import { Calendar } from 'lucide-react';

export function BookOnlineButton() {
    return (
        <a
            href="https://cal.com/sudburyschoolofmusic/lesson"
            target="_blank"
            rel="noopener noreferrer"
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '12px 20px',
                borderRadius: '9999px', // fully rounded
                backgroundColor: 'black',
                color: 'white',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '500',
                cursor: 'pointer',
                gap: '8px'
            }}
        >
            <Calendar size={20} />
            Book online
        </a>
    );
}